// UserProvider.js
import React, { useEffect, useRef, useState } from 'react';
import UserContext from './Context';
import consts from './constant';
import usercalls from './Axios'
import axios from 'axios';
import { useKucoinWebSocketProvider } from './kucoinSocket'

const UserProvider = ({ children }) => {

    const [selcOrderBook, setSelcOrderBook] = useState('');

    const [balanceUpdate, setBalanceUpdate] = useState("")

    const [balance, setBalance] = useState("")

    const [pointFilter, setPointFilter] = useState(2)

    const [quotePrecision, setQuotePrecision] = useState(0)

    const [basePrecision, setBasePrecision] = useState(0)

    const [openPositions, setOpenPositions] = useState(0)

    var [openPositionsData, setOpenPositionsData] = useState([])

    const [currentOrderData, setCurrentOrdersData] = useState([])
    const [currentOrders, setCurrentOrders] = useState(0)

    const [markPrice, setMarkPrice] = useState(0)

    const [trademode, setTrademode] = useState(null)

    const [orderHistory, setOrderHistory] = useState([])

    const [orderBookBits, setOrderBookBits] = useState([]);

    const [orderBookAsks, setOrderBookAsks] = useState([]);

    const [triggerPrice, setTriggerPrice] = useState(0);

    const [assetName, setAssetName] = useState("")

    const [currentSocketToken, setCurrentSocketToken] = useState("");


    const { kucoinSocket, sendMessage, spotConnected } = useKucoinWebSocketProvider();
    // console.log("🚀 ~ UserProvider ~ kucoinSocket:", kucoinSocket, spotConnected)

    const [spotSocket, setSpotSocket] = useState("")

    const [activeTabId, setActiveTabId] = useState(null);

    const [obPointFilter, setObPointFilter] = useState(0);
    const [futurePrices, setFuturePrice] = useState("")

    const path = usercalls();

    // const getHistory = async (placeRoute, id) => {
    //     try {
    //         setOrderHistory([])
    //         const url = `${consts.BackendUrl}/ownTrade/orderhistory?page=1&limit=5`
    //         const payload = {
    //             pair: id,
    //             type: placeRoute === "trade" ? "spot" : 'future',
    //         }
    //         const response = await path.postCall({ url, payload });
    //         const result = await response.json();
    //         if (result?.success) {
    //             setOrderHistory(result?.result?.docs);
    //         }
    //     } catch (error) {
    //         console.log("🚀 ~ getHistory ~ error:", error)
    //     }
    // }

    const [history, getHistory] = useState("")

    const token = window.localStorage.getItem("Rikosta")

    // const generateTokenCurrentSocket = async () => {
    //     try {
    //         axios.withCredentials = true;
    //         const url = `${consts.BackendUrl}/kucoin/generatekucointoken`;
    //         const { data } = await axios.get(url);
    //         if (data.success) {
    //             let str = data?.result?.replace(/^"(.*)"$/, "$1");
    //             setCurrentSocketToken(str);
    //             // console.log(str, "kucoinToken");
    //         }
    //     } catch (err) {
    //         console.log(err, "error from token")
    //     }
    // }

    // useEffect(() => {
    //     // console.log("tokensdfjsiof", token)
    //     if (token) {
    //         generateTokenCurrentSocket()
    //     }
    // }, [token])

    // const curSocPi = useRef(null);
    // const kucoinSocket = useRef(null);

    // useEffect(() => {
    //     if (currentSocketToken) {
    //         console.log(currentSocketToken, "currentSocketToken")
    //         const ws = new WebSocket(
    //             `wss://ws-api-spot.kucoin.com?token=${currentSocketToken}`
    //         );
    //         kucoinSocket.current = ws;
    //         curSocPi.current = setInterval(() => {
    //             if (kucoinSocket.current?.readyState === WebSocket.OPEN) {
    //                 const pingMsg = {
    //                     id: `ping-${Date.now()}`,
    //                     type: 'ping'
    //                 };
    //                 kucoinSocket.current?.send(JSON.stringify(pingMsg));
    //                 // console.log('Sent ping:', pingMsg.id);
    //             }
    //         }, 20000); // every 20 seconds

    //         return () => {
    //             clearInterval(curSocPi.current);
    //         }
    //     }
    // }, [currentSocketToken])

    return (
        <UserContext.Provider value={{
            selcOrderBook, setSelcOrderBook,
            balanceUpdate, setBalanceUpdate,
            balance, setBalance,
            pointFilter, setPointFilter,
            quotePrecision, setQuotePrecision,
            basePrecision, setBasePrecision,
            openPositions, setOpenPositions,
            openPositionsData, setOpenPositionsData,
            currentOrderData, setCurrentOrdersData,
            currentOrders, setCurrentOrders,
            markPrice, setMarkPrice,
            trademode, setTrademode,
            orderHistory, setOrderHistory,
            history, getHistory,
            spotSocket,
            sendMessage,
            kucoinSocket,
            spotConnected,
            orderBookBits, setOrderBookBits,
            orderBookAsks, setOrderBookAsks,
            activeTabId, setActiveTabId,
            triggerPrice, setTriggerPrice,
            obPointFilter, setObPointFilter,
            futurePrices, setFuturePrice,
            assetName, setAssetName
        }}>
            {children}
        </UserContext.Provider>
    );
};

export default UserProvider;
